/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Legends_DescriptionInputs */

const en_directory_hubs_legends_description = /** @type {(inputs: Directory_Hubs_Legends_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The all-time standout launches on Seek AI — products that kept earning attention long after their launch day.`)
};

const zh_directory_hubs_legends_description = /** @type {(inputs: Directory_Hubs_Legends_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 上历久弥坚的明星产品——发布之后仍持续赢得关注的传奇之作。`)
};

/**
* | output |
* | --- |
* | "The all-time standout launches on Seek AI — products that kept earning attention long after their launch day." |
*
* @param {Directory_Hubs_Legends_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_legends_description = /** @type {((inputs?: Directory_Hubs_Legends_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Legends_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_legends_description(inputs)
	return zh_directory_hubs_legends_description(inputs)
});
export { directory_hubs_legends_description as "directory.hubs.legends.description" }